/**
 * Cache keys, in one place so readers and invalidation can never disagree on a spelling.
 *
 * Every key starts with its ENTITY (`'shifts'`, `'allocations'`, …) so an invalidation by that first
 * segment reaches every variant of it — each day, each range.
 *
 * Per-day keys use the user's LOCAL `YYYY-MM-DD`. Every per-day reader converts that date to its UTC
 * window with `localDateToUtcStart/End`, so the local date identifies the window exactly.
 */
export const queryKeys = {
  employees: () => ['employees'] as const,
  hospitals: () => ['hospitals'] as const,
  operatingRooms: () => ['operatingRooms'] as const,
  credentials: () => ['credentials'] as const,
  users: () => ['users'] as const,
  externalMappings: (mappingType?: string) => ['externalMappings', mappingType ?? 'all'] as const,

  shiftsForDay: (date: string) => ['shifts', 'day', date] as const,
  shiftsInRange: (startUtc: string, endUtc: string) => ['shifts', 'range', startUtc, endUtc] as const,
  schedulesForDay: (date: string) => ['schedules', 'day', date] as const,
  allocationsForDay: (date: string) => ['allocations', 'day', date] as const,
};

/** The entity families, i.e. the first segment of every key above. */
export type CacheEntity =
  | 'employees'
  | 'hospitals'
  | 'operatingRooms'
  | 'credentials'
  | 'users'
  | 'externalMappings'
  | 'shifts'
  | 'schedules'
  | 'allocations';
